// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pindaodushu":"pindaodushu-1cC2VijK","imglink":"imglink-6dqXPO-i","link":"link-2JEceUa6","ml":"ml-3FqmRdn6"};